export function tenantsVisibleForSession(allTenants, {
  isTenantAdmin = false,
  tenantIdFromAuth = '',
  supportTenant = null,
} = {}) {
  const list = Array.isArray(allTenants) ? allTenants : [];
  const supportId = String(supportTenant?.tenantId || '').trim();
  if (supportId) {
    const match = list.find((tenant) => (tenant.id || tenant.tenantId) === supportId);
    return [match || {
      id: supportId,
      tenantId: supportId,
      name: supportTenant.name || 'Supported tenant',
    }];
  }
  if (isTenantAdmin && tenantIdFromAuth) {
    return list.filter((tenant) => (tenant.id || tenant.tenantId) === tenantIdFromAuth);
  }
  return list;
}
